import React, { useRef, createRef, useEffect } from 'react';
import styled from 'styled-components';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Typo } from 'tmt-ui-kit';

import { actions as galleryActions } from '~/redux/reducers/gallery';

import { path } from '~/utils/media';
import { GalleryName } from '~/utils/gallery';

const Container = styled.div`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.index}, 128px) ${props.isSeeMore ? '50px' : ''}`};
  grid-column-gap: 8px;
  margin-top: 8px;
  margin-bottom: 20px;
  @media (max-width: 700px) {
    font-size: 12px;
    grid-template-columns: ${props => `repeat(${props.index}, 100px) ${props.isSeeMore ? '30px' : ''}`};
  }
  @media (max-width: 500px) {
    grid-template-columns: ${props => `repeat(${props.index}, 80px) ${props.isSeeMore ? '30px' : ''}`};
  }
  @media (max-width: 410px) {
    grid-template-columns: ${props => `repeat(${props.index}, 70px) ${props.isSeeMore ? '30px' : ''}`};
  }
  @media (max-width: 375px) {
    grid-template-columns: ${props => `repeat(${props.index}, 60px) ${props.isSeeMore ? '30px' : ''}`};
  }
`;

const GalleryCard = styled.div`
  display: block;
  user-select: none;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  width: 128px;
  height: 128px;
  background: linear-gradient(118deg,#f6f9fb,#e2ebef);
  background: ${props => (props.bg ? `url(${props.bg})` : 'linear-gradient(118deg,#f6f9fb,#e2ebef)')};
  background-size: cover;

  @media (max-width: 700px) {
    width: 100px;
    height: 100px;
  }
  @media (max-width: 500px) {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 410px) {
    width: 70px;
    height: 70px;
  }
  @media (max-width: 375px) {
    width: 60px;
    height: 60px;
  }
`;

const SeeMore = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: solid 1px #b3b3b3;
  font-weight: 800;
`;

const enhance = connect(
  null,
  {
    openAndGoTo: galleryActions.openAndGoTo,
  }
);

const GalleryAllReview = (props) => {
  const { images, openAndGoTo, defaultAlt } = props;
  const imageRef = useRef(images.map(() => createRef()));

  useEffect(() => {
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target) {
          const dom = entry.target;
          dom.style.backgroundImage = `url(${dom.dataset.img})`;
          observer.unobserve(entry.target);
        }
      });
    });
    if (imageRef.current) {
      imageRef.current.forEach(t => t.current && observer.observe(t.current));
    }
  }, []);

  return (
    <Container index={images.slice(0, 4).length} isSeeMore={images.length > 4}>
      {images.slice(0, 4).map((img, index) => (
        <GalleryCard
          ref={imageRef.current[index]}
          key={img}
          data-img={path(img, 'thumbnail')}
          onClick={() => openAndGoTo(index, GalleryName.LOCAL_TABLE, { images: images.map(imagePath => ({ image: imagePath, caption: '' })), defaultAlt })}
        />
      ))}
      {(images.length > 4) && (
        <SeeMore
          onClick={() => openAndGoTo(4, GalleryName.LOCAL_TABLE, { images: images.map(imagePath => ({ image: imagePath, caption: '' })), defaultAlt })}
        >
          . . .
        </SeeMore>
      )}
    </Container>
  );
};

export default enhance(GalleryAllReview);
